import { request } from '@/utils/request'
//查找用户信息
export function getUserNews(sessionId) {
    return request({
        url: `/api/v1/ctMember/member/getInformation;JSESSIONID=${sessionId}`,
        method: 'get',
    });
}

//更新头像
export function editImg(sessionId,photoBase64) {
    return request({
        url: `/api/v1/ctMember/member/edit/image;JSESSIONID=${sessionId}`,
        method: 'post',
        data: {
            photoBase64
        }
    });
}

//上传二寸照
export function editPhoto(sessionId,certificateBase64) {
    return request({
        url: `/api/v1/ctMember/member/edit/image;JSESSIONID=${sessionId}`,
        method: 'post',
        data: {
            certificateBase64
        }
    });
}

//查看已报名的培训班
export function getSignUpTrains(sessionId) {
    return request({
        url: `/api/v1/course/courseInfo/getTrainSignuped;JSESSIONID=${sessionId}`,
        method: 'get',
    });
}
//获取个人学习进度
export function getStudyRate(sessionId,trainSignupId,pageNo, pageSize) {
    return request({
        url: `/api/v1/course/courseInfo/getStudyRate;JSESSIONID=${sessionId}`,
        method: 'get',
        params: {
            trainSignupId,
            pageNo,
            pageSize
        }
    });
}
//修改密码
export function changePassword(sessionId,oldPassword, password) {
    return request({
        url: `/api/v1/ctMember/member/update/password;JSESSIONID=${sessionId}`,
        method: 'post',
        data: {
            oldPassword,
            password,
        }
    });
}

//忘记密码
export function resetPassword(showName, veriCode='',idNumber='', password='') {
    return request({
        url: `/api/v1/ctMember/member/reset/password`,
        method: 'post',
        data: {
            showName,
            veriCode,
            idNumber,
            password,
        }
    });
}


//获取个人证书
export function getCertIssueLis(sessionId,valid,pageNo,pageSize) {
    return request({
        url: `/api/v1/ctpost/postCertificate/getList;JSESSIONID=${sessionId}`,
        method: 'get',
        params: {
            valid,
            pageNo,
            pageSize
        }
    });
}

//删除证书
export function deleteCers(sessionId,id) {
    return request({
        url: `/api/v1/ctpost/postCertificate/deleteInfo;JSESSIONID=${sessionId}`,
        method: 'get',
        params: {
            id
        }
    });
}

//添加证书

export function addCer(sessionId,data) {
    return request({
        url: `/api/v1/ctpost/postCertificate/saveInfo;JSESSIONID=${sessionId}`,
        method: 'post',
        data:{
            ...data
        }
    });
}

//我的培训班
export function myTrainClassList(sessionId,pageNo,pageSize) {
    return request({
        url: `/api/v1/course/courseInfo/myTrainClassList;JSESSIONID=${sessionId}`,
        method: 'get',
        params: {
            pageNo,
            pageSize
        }
    });
}


//培训班校验
export function checkTrainStatus(sessionId,categoryId) {
    return request({
        url: `/api/v1/course/courseInfo/checkTrainStatus;JSESSIONID=${sessionId}`,
        method: 'get',
        params: {
            categoryId
        }
    });
}
